import { cancelConfirmMw } from '@svenskaspelab/nova-payment-sport';
import type { DialogConfig } from '@svs/nova-foundation/nextjs/dialog';
import type { ReactNode } from 'react';

/**
 * Creates a cancel confirmation middleware with the provided showDialog function.
 *
 * @param showDialog Dialog function to show confirmation dialog
 * @param icon Optional icon to show in the dialog
 * @returns Cancel confirmation middleware
 */
export function cancelConfirm(
  showDialog: (props: DialogConfig, meta?: string[]) => Promise<void>,
  icon?: ReactNode
): ReturnType<typeof cancelConfirmMw> {
  return cancelConfirmMw(
    (cancelContext) =>
      new Promise((resolve, reject) => {
        const count: number = cancelContext?.count || 1;
        const gamesString = count > 1 ? 'spelen' : 'spelet';
        const title = `Vill du annullera ${gamesString}?`;
        showDialog({
          title: title,
          description: '',
          icon: icon,
          buttons: {
            primary: {
              label: 'Fortsätt',
              action: () => {
                resolve(); // Continue with cancellation
              },
            },
            secondary: {
              label: 'Avbryt',
              action: () => {
                reject(new Error('Cancel aborted by customer')); // Cancel
              },
            },
          },
        }).catch(() => {
          // If the dialog is closed in another way (ESC, click outside, etc.)
          reject(new Error('Cancel aborted by customer'));
        });
      })
  );
}
